import { PatientCareProviderModel } from "one-card-pcp";

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * pcp Component
 * @param response has the backend
 * pcp response
 * @param context has settings etc..
 */
interface DataItem {
  id: string;
  deptname: string;
  isDeleted: boolean;
}
const specialitycode:DataItem[]=[
  {
    "id": "0001",
    "deptname": "CARD",
    "isDeleted": false
  },
  {
    "id": "0002",
    "deptname": "FP",
    "isDeleted": false
  },
  {
    "id": "0003",
    "deptname": "IM",
    "isDeleted": false
  },
  {
    "id": "0004",
    "deptname": "OBGYN",
    "isDeleted": false
  },
  {
    "id": "0005",
    "deptname": "PEDS",
    "isDeleted": false
  },
  {
    "id": "0006",
    "deptname": "BH",
    "isDeleted": false
  },
  {
    "id": "0007",
    "deptname": "Test For Training",
    "isDeleted": false
  },
  {
    "id": "0008",
    "deptname": "IM1",
    "isDeleted": false
  },
  {
    "id": "0009",
    "deptname": "Diab Panel",
    "isDeleted": false
  },
  {
    "id": "01",
    "deptname": "Genrl Pract",
    "isDeleted": false
  },
  {
    "id": "02",
    "deptname": "Genrl Surg",
    "isDeleted": false
  },
  {
    "id": "03",
    "deptname": "Allergy/Immun",
    "isDeleted": false
  },
  {
    "id": "04",
    "deptname": "Otolaryngology",
    "isDeleted": false
  },
  {
    "id": "05",
    "deptname": "Anethesiology",
    "isDeleted": false
  },
  {
    "id": "06",
    "deptname": "Cardiology",
    "isDeleted": false
  },
  {
    "id": "07",
    "deptname": "Dermatology",
    "isDeleted": false
  },
  {
    "id": "08",
    "deptname": "Family Pract",
    "isDeleted": false
  },
  {
    "id": "09",
    "deptname": "Gynecology, DO",
    "isDeleted": false
  },
  {
    "id": "10",
    "deptname": "Gastroentergy",
    "isDeleted": false
  },
  {
    "id": "10-25",
    "deptname": "OB 10-25 Wks",
    "isDeleted": false
  },
  {
    "id": "11",
    "deptname": "Internal Med",
    "isDeleted": false
  },
  {
    "id": "12",
    "deptname": "Osteopath Thpy",
    "isDeleted": false
  },
  {
    "id": "12-20",
    "deptname": "12-20 Wk Labs",
    "isDeleted": false
  },
  {
    "id": "13",
    "deptname": "Neurology",
    "isDeleted": false
  },
  {
    "id": "14",
    "deptname": "Neurosurgery",
    "isDeleted": false
  }
]
function getDescriptionById(data:any, id: string) {
  const foundItem= data.find((item:any) => item.id === id);
  return foundItem ;
}
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */

    let pdata: PatientCareProviderModel[] = [];

    let result :any = {
        pcp:pdata,
        error:undefined

    }
    const { log } = context;
     // if (response && (response.status >= 400 || response.type == "error")) {
    //    result.error=response;
    // }
    if (response && (response?.success === 'true')) {
        result.error=response;
     }
 
     if (response?.length > 0) {
        response?.forEach((pcpdata: any) => {
            let pcpobj: PatientCareProviderModel = {};
            //OR condition was added for NYCHHC as the response was different
            const dpt=getDescriptionById(specialitycode,pcpdata.specialitycode)
            let dptarray=[];
            dptarray.push(dpt)
            pcpobj.name = pcpdata.pcpName ?? '';
            pcpobj.address = pcpdata.address1 ?? '';
            pcpobj.phonenumber = pcpdata.phonenumber ?? '';
            pcpobj.department=getDescriptionById(specialitycode,pcpdata.specialityCode)?.deptname
            pdata.push(pcpobj)
        });
    }
    result.pcp=pdata;
    log.debug(
        "ccw-gadget,pcp-epic",
        "pcp-epic transforamtion response ", {
        result
    });
    return result;
}